export const MgmtProjects = [
  {
    title: "Cost Management Plans & Analysis",
    subtitle: "Budgeting",
    description:
      "Projects where I needed to come up with a cost management plan or create a cost analysis.",
    image: "./Cost_Management.gif",
    link: "https://drive.google.com/drive/u/0/folders/1pSslpAYkJMKfCYBA3hr6g3T7oUrW4fXg",
  },
  {
    title: "Project Outlines and Gantt Charts",
    subtitle: "MS Project",
    description:
      "Projects where I used MS Project to create both an outline of work and Gantt Charts that focused on the critical path.",
    image: "./Gantt_Chart_2.gif",
    link: "https://drive.google.com/drive/u/0/folders/1d8qNrf9PTM3-r-Uu5cW3YRsIEqJD9H0r",
  },
  {
    title: "Fishbone Diagram",
    subtitle: "Error Handling and Tracing",
    description:
      "Projects where I used Visio to create a Ishikawa diagram based on an issue that popped up during the project timeline.",
    image: "./Fishbone_Diagram_2.gif",
    link: "https://drive.google.com/drive/u/0/folders/1znWXppIaqKhCDc0Ev2an505qNqMabiKQ",
  },
  {
    title: "Critical Path Diagram",
    subtitle: "Project Timeline",
    description:
      "Project where I created a manual critical path diagram to calculate the optimum path for the project.",
    image: "./Critical_Path_Diagram.gif",
    link: "https://drive.google.com/drive/u/0/folders/1eUWzJmF24Oak2uEAAUjg6C0tNFhJ9zns",
  },
];
export const SftwProjects = [
  {
    title: "Portfolio",
    subtitle: "React and Tailwind css",
    description:
      "This portfolio page was a project I  elected to work on using strictly React and Tailwind css. Showcases completed projects and projects in progress as well.",
    image: "./Portfolio.gif",
    link: "https://github.com/ARivers223/Portfolio/tree/master/src",
  },
  {
    title: "ERD of Student Music Event",
    subtitle: "SQL Focus",
    description:
      "An ERD created based off an event where students could participate in a music showcase event that would conclude with rewards given based on performance.",
    image: "./Music_Event_ERD.gif",
    link: "https://drive.google.com/drive/u/0/folders/1RT_FED2jweCoWYxuci2QRMCkbTEA8Nij",
  },
  {
    title: "C.R.U.D and other pattern designs",
    subtitle: "ASP.Net, C#, and SQL Server",
    description:
      "Multiple projects previously completed that focus on development using ASP.net, C#, and SQL Server with html elements. Decorator pattern, C.R.U.D, factory patterns used here as well",
    image: "./project-3.gif",
    link: "https://github.com/ARivers223/Asp.net/tree/master/desktop/Asp",
  },
  {
    title: "Ecommerence and algorithm work",
    subtitle: "JS, HTML, and CSS",
    description:
      "Two smaller projects that comprised of a popular algorithm question frequently used and an ecommerence webpage.",
    image: "./project-4.gif",
    link: "https://github.com/ARivers223/JS-HTML-CSS/tree/master/desktop/Js%2Chtml%2Ccss",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "PHP/Laravel",
  "Jira",
  "Rapid Learning",
  "JavaScript",
  "Leadership",
  "Team Collaboration",
];



// WEBPACK FOOTER //
// ./src/data.js